import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  Box,
} from "@material-ui/core";

import logo from "../logo.svg";

export default ({ setTemplateHistoryIsOpen, setBoardLogOpen }) => {
  const [anchorEl, setAnchorEl] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickTemplateHistory = () => {
    setTemplateHistoryIsOpen(true);
    handleClose();
  };


  const handleClickBoardLogOpen= () => {
    setBoardLogOpen(true);
    handleClose();
  };

  return (
    <AppBar color="primary">
      <Toolbar position="relative" style={{ display: "flex" }}>
        <Typography
          style={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box style={{ display: "flex", alignItems: "center" }}>
            <img width={75} src={logo} alt="Dish Netowork" />
            <span style={{ marginLeft: 20 }}>Features Generator</span>
          </Box>
          <Box>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
              style={{
                color: "white",
                border: "1px solid white",
                borderRadius: 10,
                padding: "5px 20px",
              }}
            >
              Menu
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              style={{ top: 50 }}
            >
              <MenuItem onClick={handleClickTemplateHistory}>
                Template history
              </MenuItem>
              <MenuItem onClick={handleClickBoardLogOpen}>
                Board log
              </MenuItem>
            </Menu>
          </Box>
        </Typography>
      </Toolbar>
    </AppBar>
  );
};
